// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { logoLinksSearchStyles } from "@stoneage/Overrides/Widgets/Header/LogoLinksSearch";
import { css } from "styled-components";
import { color, layoutContainer, xScreen } from "@stoneage/XDL/Utilities";
import { DivWrapper } from "@stoneage/XDL/constants";
import IconSearch from "@stoneage/XDL/Icons/IconSearch";

logoLinksSearchStyles.container = {
    css: css`
        background: ${color("common.white")};
        ${xScreen("gt", "lg")} {
            display: grid;
            grid-template-columns: 174px 1fr auto;
            grid-template-areas: "logo search actions";
            gap: 0 33px;
            ${layoutContainer}
        }
    `,
};

logoLinksSearchStyles.innerContainer = {
    css: css`
        display: grid;
        grid-template-columns: 1fr auto;
        grid-template-areas: "logo actions";
        gap: 0 20px;
        border-bottom: 1px solid ${color("common.border")};

        ${layoutContainer}

        ${xScreen("gt", "lg")} {
            border-bottom: 0;
            display: contents;
        }
    `,
};

logoLinksSearchStyles.logoWrapper = {
    css: css`
        grid-area: logo;
        padding: 8px 0;
        display: flex;
        align-items: center;
        gap: 16px;
    `,
};

logoLinksSearchStyles.searchMenuWrapper = {
    css: css`
        grid-area: search;
        flex: 1 1 0;

        & > ${DivWrapper} {
            padding: 8px 0;
        }

        ${xScreen("lte", "md")} {
            background: ${color("common.ui4")};
            overflow: hidden;

            & > ${DivWrapper} {
                ${layoutContainer}
                padding: 5px 0;
            }

            /* Transition states */
            &.search-enter {
                height: 0;
            }
            &.search-enter-active {
                height: var(--search-height);
                transition: height 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            }
            &.search-enter-done {
                height: var(--search-height);
            }
            &.search-exit {
                height: var(--search-height);
            }
            &.search-exit-active {
                height: 0;
                transition: height 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            }
            &.search-exit-done {
                height: 0;
                overflow: hidden;
            }
        }
    `,
};

logoLinksSearchStyles.actionsWrapper = {
    css: css`
        grid-area: actions;

        display: flex;
        align-items: center;
        gap: 12px;
        ${DivWrapper},
        .floating-tooltip {
            height: 100%;
        }
    `,
};

logoLinksSearchStyles.searchHeaderClickable = {
    icon: {
        src: IconSearch,
    },
    clickable: {
        css: css`
            ${xScreen("gt", "lg")} {
                display: none;
            }
        `,
    },
};
